import React, { FC } from 'react';

import { FormikSelectField } from '~/@components/FormikFields';
import { LocalizableText } from '~/@components/LocalizableText';
import { DeliveryLineStatus } from '~/graphql';
import i18n from '~/i18n';

import { useDeliveryLineFormikContext } from './DeliveryLineFormikCommon';

export type IDisplayDeliveryLineStatus = {
    value: DeliveryLineStatus;
    label: string;
};

export const DeliveryLineEditStatusSelect: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    const formik = useDeliveryLineFormikContext();

    const availableStatuses: DeliveryLineStatus[] = formik.values.isVerified
        ? [DeliveryLineStatus.VERIFIED]
        : formik.values.deliveryLine?.status === DeliveryLineStatus.DELIVERING
        ? [DeliveryLineStatus.DELIVERING, DeliveryLineStatus.DELIVERED]
        : formik.values.deliveryLine?.status === DeliveryLineStatus.EXCAVATED
        ? [DeliveryLineStatus.EXCAVATED, DeliveryLineStatus.DELIVERED]
        : [DeliveryLineStatus.DELIVERED];

    return (
        <FormikSelectField
            label={<LocalizableText code={'DeliveryLineCard.status'} />}
            name={'status'}
            formik={formik}
            items={availableStatuses.map(s => ({
                value: s,
                label: i18n.DeliveryLineStatuses[s],
            }))}
            renderValue={(item: IDisplayDeliveryLineStatus) => item.label}
            keyGetter={(item: IDisplayDeliveryLineStatus) => item.value}
            disabled={disabled}
            addEmptyOption={false}
        />
    );
};
